import { PalmettoTag, PalmettoTooltip } from '@palmetto/dsm-components';

// DataTable cells are a fixed-height single line, so tags can't wrap.
const MAX_VISIBLE_UTILITIES = 1;

// The tag label sits in an inner span, so the ellipsis has to target it rather than the tag itself.
const TRUNCATING_TAG_CLASS = 'max-w-full [&>span]:min-w-0 [&>span]:truncate';

// DataTable rows clip overflow; fixed positioning keeps the tooltip visible.
const TOOLTIP_POSITIONING = { strategy: 'fixed', placement: 'top', gutter: 4 } as const;

export interface UtilityTagsProps {
  names: string[];
}

export const UtilityTags = ({ names }: UtilityTagsProps) => {
  const visible = names.slice(0, MAX_VISIBLE_UTILITIES);
  const hidden = names.slice(MAX_VISIBLE_UTILITIES);

  return (
    <div className="flex flex-row flex-nowrap items-center gap-4 overflow-hidden whitespace-nowrap">
      {visible.map((name) => (
        <span key={name} className="min-w-0" title={name}>
          <PalmettoTag label={name} className={TRUNCATING_TAG_CLASS} />
        </span>
      ))}
      {hidden.length > 0 && (
        <PalmettoTooltip content={hidden.join(', ')} position="top-center" positioning={TOOLTIP_POSITIONING}>
          <button type="button" className="shrink-0" aria-label={`${hidden.length} more utilities`}>
            <PalmettoTag label={`+${hidden.length}`} />
          </button>
        </PalmettoTooltip>
      )}
    </div>
  );
};
